





























import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class LogoUpload extends Vue {
    @Prop() url: any;
    @Prop() uploadLogo: any;
    @Prop() error: any;

    get logoUrl(): string {
        return this.url && this.url !== ""
            ? this.url
            : "https://via.placeholder.com/200/FFFFFF";
    }
}
